export default {
    name: 'currency',
    data: () => ({
        currency: {
            value: null,
            currency: 'uzs',
            number_of_zero: 2
        }
    }),
    methods: {
        async update_currency() {
            this.$communicator.then(this, await this.$communicator('update_currency', {params: this.currency}))
            this.edit_currency = false
            this.$toast.success("Success", {timeout: 2000});
            this.get_currency()
        },
        async get_currency() {
            const res = this.$communicator.then(this, await this.$communicator('get_currency'))
            if (res) {
                this.currency = this.$copy(res)
                if (res.currency) {
                    this.$store.commit('setCurrentCurrency', res.currency)
                    this.$store.commit('setCurrencyZeros', res.number_of_zero)
                }
            }
        }
    },
    mounted() {
        this.get_currency()
    }
}
